"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var observer_1 = require("./observer");

exports.default = observer_1.default; //# sourceMappingURL={"version":3,"file":"module.js","sourceRoot":"","sources":["module.tsx"],"names":[],"mappings":";;AAAA,uCAAqC;AAA5B,6BAAA,OAAO,CAAA"}